export const DOMAIN_ENUM = {
    // Common
    "Operator": "BE_OPERATOR",
    "HttpMethod": "BE_HTTP_METHOD",
    "Method": "BE_METHOD",
    "Priority": "BE_PRIORITY",
    "TimeUnit": "BE_TIME_UNIT",
    "HistorySource": "BE_HISTORY_SOURCE",

    // User
    "UserRole": "BE_USER_ROLE",
    "UserState": "BE_USER_STATE",

    // Member
    "MemberRole": "BE_MEMBER_ROLE",
    "MemberState": "BE_MEMBER_STATE",
    "DepartmentMemberRole": "BE_DEPARTMENT_MEMBER_ROLE",

    // Document Participant Actor (액션 수행자 유형)
    "DocumentParticipantActorType": "BE_DOCUMENT_PARTICIPANT_ACTOR_TYPE",

    // Label
    "LabelType": "BE_LABEL_TYPE",
    "LabelReferenceType": "BE_LABEL_REFERENCE_TYPE",

    // Seal
    "SealType": "BE_SEAL_TYPE",
    "SealState": "BE_SEAL_STATE",
    "SealStatus": "BE_SEAL_STATUS",
    "SealHistoryAction": "BE_HISTORY_ACTION",
    "SealLedgerStatus": "BE_SEAL_LEDGER_STATUS",
    "SealLedgerConvertStatus": "BE_SEAL_LEDGER_CONVERT_STATUS",
    "SealLedgerReferenceType": "BE_SEAL_LEDGER_REFERENCE_TYPE",

    // Document Template
    "DocumentTemplateState": "BE_DOCUMENT_TEMPLATE_STATE",
    "DocumentTemplateStatus": "BE_DOCUMENT_TEMPLATE_STATUS",
    "DocumentTemplateHistoryAction": "BE_HISTORY_ACTION",
    "DocumentTemplateFavoriteReferenceType": "BE_DOCUMENT_TEMPLATE_FAVORITE_REFERENCE_TYPE",

    // Document Draft
    "DocumentDraftStatus": "BE_DOCUMENT_DRAFT_STATUS",
    "DocumentDraftHistoryAction": "BE_HISTORY_ACTION",

    // Document
    "BaseDocumentType": "BE_BASE_DOCUMENT_TYPE",
    "DocumentStatus": "BE_DOCUMENT_STATUS",
    "DocumentConvertStatus": "BE_DOCUMENT_CONVERT_STATUS",
    "DocumentDataType": "BE_DOCUMENT_DATA_TYPE",
    "DocumentLabelReferenceType": "BE_DOCUMENT_LABEL_REFERENCE_TYPE",
    "DocumentDownloadDomain": "BE_DOCUMENT_DOWNLOAD_DOMAIN",
    "DocumentExtractDataDomain": "BE_DOCUMENT_EXTRACT_DATA_DOMAIN",
    "DocumentProcessHistoryType": "BE_DOCUMENT_PROCESS_HISTORY_TYPE",
    "DocumentProcessHistoryReferenceType": "BE_DOCUMENT_PROCESS_HISTORY_REFERENCE_TYPE",
    "DocumentSealHistoryAction": "BE_DOCUMENT_SEAL_HISTORY_ACTION",

    // Document Resource
    "DocumentResourceConvertStatus": "BE_DOCUMENT_RESOURCE_CONVERT_STATUS",

    // Document Requester
    "DocumentRequesterStatus": "BE_DOCUMENT_REQUESTER_STATUS",

    // Document Revoker
    "DocumentRevokerType": "BE_DOCUMENT_REVOKER_TYPE",
    "DocumentRevokerReferenceType": "BE_DOCUMENT_REVOKER_REFERENCE_TYPE",

    // Document Approver
    "DocumentApproverStatus": "BE_DOCUMENT_APPROVER_STATUS",
    "ApproverStatus": "BE_DOCUMENT_APPROVER_STATUS",

    // Document Seal Approver
    "DocumentSealApproverStatus": "BE_DOCUMENT_SEAL_APPROVER_STATUS",

    // Document Seal Manager
    "DocumentSealManagerStatus": "BE_DOCUMENT_SEAL_MANAGER_STATUS",

    // Resource
    "ResourceType": "BE_RESOURCE_TYPE",
    "ResourceReferenceType": "BE_RESOURCE_REFERENCE_TYPE",

    // Attachment
    "AttachmentReferenceType": "BE_ATTACHMENT_REFERENCE_TYPE",

    // Role
    "RoleType": "BE_ROLE_TYPE",

    // Callback
    "CallbackReferenceType": "BE_CALLBACK_REFERENCE_TYPE",

    // Workspace
    "WorkspaceConfigKey": "BE_WORKSPACE_CONFIG_KEY",

    // Owner

    // Published Department

    // Notification
    "NotificationType": "BE_NOTIFICATION_TYPE",
    "NotificationContext": "BE_NOTIFICATION_CONTEXT",
    "NotificationStatus": "BE_NOTIFICATION_STATUS",
    "NotificationReferenceType": "BE_NOTIFICATION_REFERENCE_TYPE",
    "NotificationReceiverReferenceType": "BE_NOTIFICATION_RECEIVER_REFERENCE_TYPE",

    // Hook
    "HookEventDomain": "BE_HOOK_EVENT_DOMAIN",
    "HookEventType": "BE_HOOK_EVENT_TYPE",
    "HookEventReferenceType": "BE_HOOK_EVENT_REFERENCE_TYPE",
    "HookReferenceType": "BE_HOOK_REFERENCE_TYPE",
    "HookStatus": "BE_HOOK_STATUS",
    "WebhookHistoryResult": "BE_WEBHOOK_HISTORY_RESULT",

    // Token

    "ActedRole": "BE_ACTED_ROLE",
} as const;
